import { Component, OnInit, inject } from '@angular/core';

import { ImageService } from '@core/services/image/image.service';

@Component({
  selector: 'ux-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.less'],
  imports: [],
})
export class ImageComponent implements OnInit {
  imageService = inject(ImageService);

  constructor() {}

  ngOnInit() {}
}
